import { createTheme, ThemeProvider, useMediaQuery } from '@mui/material';
import { createContext, useEffect, useMemo, useState } from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom'; // Import Router, Routes, and Route
import RealtimeDemoRTC from './extra/RealtimeDemoRTC';
import GameDisplay from './GameDisplay';
import Login from './Login';
import './Main.css';
import MainMenu from './MainMenuV1'; // Import your new GameSelection component
// Create a context to provide the base URL globally
export const ApiContext = createContext();

function App() {
  // Fetch the base URL from the environment variable or use the default one
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [token, setToken] = useState(localStorage.getItem('token'));

  const [themeMode, setThemeMode] = useState('dark'); // Default to system
  const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');
  const muiTheme = useMemo(() => {
    const mode =
      themeMode === 'system' ? (prefersDarkMode ? 'dark' : 'light') : themeMode;

    return createTheme({
      palette: {
        mode,
      },
    });
  }, [themeMode, prefersDarkMode]);


  useEffect(() => {
    const styleTagId = 'dynamic-scrollbar-style';
    let styleTag = document.getElementById(styleTagId);

    const isDark = muiTheme.palette.mode === 'dark';

    const darkScrollbarCSS = `
      ::-webkit-scrollbar {
        width: 8px;
        height: 8px;
      }
  
      ::-webkit-scrollbar-track {
        background: #1e1e1e;
      }
  
      ::-webkit-scrollbar-thumb {
        background: #555;
        border-radius: 10px;
      }
  
      ::-webkit-scrollbar-thumb:hover {
        background: #777;
      }
    `;

    const lightScrollbarCSS = `
      ::-webkit-scrollbar {
        width: 8px;
        height: 8px;
      }
  
      ::-webkit-scrollbar-track {
        background: #f1f1f1;
      }
  
      ::-webkit-scrollbar-thumb {
        background: #ccc;
        border-radius: 10px;
      }
  
      ::-webkit-scrollbar-thumb:hover {
        background: #888;
      }
    `;

    if (!styleTag) {
      styleTag = document.createElement('style');
      styleTag.id = styleTagId;
      document.head.appendChild(styleTag);
    }

    styleTag.innerHTML = isDark ? darkScrollbarCSS : lightScrollbarCSS;
  }, [muiTheme.palette.mode]);


  return (
    <ThemeProvider theme={muiTheme}>
      <ApiContext.Provider value={BASE_URL}>
        <Router> {/* Wrap everything in Router */}
          <Routes>
            <Route path="/" element={!token ? <Login setToken={setToken} /> : <MainMenu token={token} setToken={setToken} setThemeMode={setThemeMode} />} />
            <Route path="/game/:game_id" element={!token ? <Login setToken={setToken} /> : <GameDisplay token={token} setToken={setToken} />} />
            <Route path="/realtime-voice-demo-rtc" element={!token ? <Login setToken={setToken} /> : <RealtimeDemoRTC token={token} />} />
          </Routes>
        </Router>
      </ApiContext.Provider>
    </ThemeProvider>
  );
}

export default App;
